import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../app/reducers';
import businessUnits from './businessUnits';
import { SupportedLanguageOptions } from '../footer/Footer';
const serverErrorMiddleware = (store) => (next) => (action) => {
    if (!action || !action.fiveHundred) {
        return next(action);
    }
    const newAction = {
        type: 'SERVER_FIVE_HUNDRED',
    };
    return next(newAction);
};

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let middlewares = [thunkMiddleware, serverErrorMiddleware];

if (process.env.NODE_ENV !== 'production') {
    middlewares = [...middlewares, loggerMiddleware];
}

function setStore(preloadedState) {
    return createStore(
        rootReducer,
        preloadedState,
        composeEnhancers(applyMiddleware(...middlewares)),
    );
}

const userSetLocale = localStorage.getItem('userSetLocale');
const supportedLanguageList = Object.values(SupportedLanguageOptions).map((item) => item.value);
const lowerCaseList = supportedLanguageList.map((item) => item.toLowerCase());
const isSupported = lowerCaseList.includes(userSetLocale?.toLowerCase());
isSupported || localStorage.removeItem('userSetLocale');
const store = setStore({
    app: {
        businessUnits,
        currency: null,
        locale: isSupported
            ? supportedLanguageList[lowerCaseList.indexOf(userSetLocale.toLowerCase())]
            : undefined,
        memberLoggedIn: false,
        clientConfig: {},
        appConfig: {},
    },
    member: {},
});

export default store;
